import { notificationLogsId, type NotificationLogsId } from "./NotificationLogs";
import type { ColumnType, Selectable, Insertable, Updateable } from "kysely";
import { z } from "zod";

/** Identifier type for notification_schema_errors */
export type NotificationSchemaErrorsId = string & { __flavor: "NotificationSchemaErrorsId" };

/**
 * Represents the table public.notification_schema_errors
 * @uniqueConstraints {"notification_schema_errors_pkey":{"name":"notification_schema_errors_pkey","isPrimary":true,"isUnique":true,"columns":[{"name":"id","definition":"id","predicate":null}]},"notification_schema_errors_notification_log_id_idx":{"name":"notification_schema_errors_notification_log_id_idx","isPrimary":false,"isUnique":false,"columns":[{"name":"notification_log_id","definition":"notification_log_id","predicate":null}]},"notification_schema_errors_created_at_idx":{"name":"notification_schema_errors_created_at_idx","isPrimary":false,"isUnique":false,"columns":[{"name":"created_at","definition":"created_at","predicate":null}]}}
 */
export default interface NotificationSchemaErrorsTable {
  id: ColumnType<
    NotificationSchemaErrorsId,
    NotificationSchemaErrorsId | undefined,
    NotificationSchemaErrorsId
  >;

  notificationLogId: ColumnType<NotificationLogsId, NotificationLogsId, NotificationLogsId>;

  expectedSchema: ColumnType<unknown, unknown, unknown>;

  providedData: ColumnType<unknown, unknown, unknown>;

  validationErrors: ColumnType<unknown, unknown, unknown>;

  createdAt: ColumnType<Date, Date | string | undefined, Date | string>;
}

export type NotificationSchemaErrors = Selectable<NotificationSchemaErrorsTable>;

export type NewNotificationSchemaErrors = Insertable<NotificationSchemaErrorsTable>;

export type NotificationSchemaErrorsUpdate = Updateable<NotificationSchemaErrorsTable>;

export const notificationSchemaErrorsId =
  z.string() as unknown as z.Schema<NotificationSchemaErrorsId>;

export const notificationSchemaErrors = z.object({
  id: notificationSchemaErrorsId,
  notificationLogId: notificationLogsId,
  expectedSchema: z.unknown(),
  providedData: z.unknown(),
  validationErrors: z.unknown(),
  createdAt: z.date(),
});

export const notificationSchemaErrorsInitializer = z.object({
  id: notificationSchemaErrorsId.optional(),
  notificationLogId: notificationLogsId,
  expectedSchema: z.unknown(),
  providedData: z.unknown(),
  validationErrors: z.unknown(),
  createdAt: z.date().optional(),
});

export const notificationSchemaErrorsMutator = z.object({
  id: notificationSchemaErrorsId.optional(),
  notificationLogId: notificationLogsId.optional(),
  expectedSchema: z.unknown().optional(),
  providedData: z.unknown().optional(),
  validationErrors: z.unknown().optional(),
  createdAt: z.date().optional(),
});

// ── constraints for NotificationSchemaErrors ─────────────────────────────────
export const NotificationSchemaErrorsConstraints = {
  notification_schema_errors_pkey: {
    name: "notification_schema_errors_pkey",
    isPrimary: true,
    isUnique: true,
    columns: [{ name: "id", definition: "id", predicate: null }],
  },
  notification_schema_errors_notification_log_id_idx: {
    name: "notification_schema_errors_notification_log_id_idx",
    isPrimary: false,
    isUnique: false,
    columns: [{ name: "notification_log_id", definition: "notification_log_id", predicate: null }],
  },
  notification_schema_errors_created_at_idx: {
    name: "notification_schema_errors_created_at_idx",
    isPrimary: false,
    isUnique: false,
    columns: [{ name: "created_at", definition: "created_at", predicate: null }],
  },
} as const;
export type NotificationSchemaErrorsConstraintsType = typeof NotificationSchemaErrorsConstraints;
